import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, Divider, ToggleButton, Card, FormControl, IconButton, Autocomplete, Modal, Grid, Checkbox, FormLabel, Chip, InputAdornment } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';

import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import Moment from 'moment';
import * as FileSaver from 'file-saver';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
// components
import AddIcon from "@mui/icons-material/Add";
import { Icon } from '@iconify/react';
import Iconify from '../../Iconify';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------------------------------

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};


export default function ProjectTeamManagementDetailsPage() {
    const CustomPagination = (props) => <GridPagination {...props} />;

    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const userClientId = CurrentLoggedInUser?.UserClientId;

    const [isLoading, setIsLoading] = useState();

    // create team
    const [teamName, setTeamName] = useState('');
    const [clientTeam, setClientTeam] = useState("");
    const [selectedClientTeam, setSelectedClientTeam] = useState([]);
    const [projectTeam, setProjectTeam] = useState("");
    const [selectedProjectTeam, setSelectedProjectTeam] = useState([]);
    const [executiveTeam, setExecutiveTeam] = useState([]);
    const [selectedExecutiveTeam, setSelectedExecutiveTeam] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [createNew, setCreateNew] = useState(false);

    // filter ddl
    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [executive, setExecutive] = useState('');
    const [selectedExecutive, setSelectedExecutive] = useState([]);
    const [team, setTeam] = useState("");
    const [selectedTeam, setSelectedTeam] = useState([]);

    // filter team -left section
    const [teamData, setTeamData] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);
    const [showInactive, setShowInactive] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [addModal, setAddModal] = useState(false);
    const [addMemberData, setAddMemberData] = useState([]);

    const [searchExecutiveMemberText, setSearchExecutiveMemberText] = useState("");
    const [pageSize, setPageSize] = useState(25);
    const [checkboxSelection, setCheckboxSelection] = useState([]);
    const [step, setStep] = useState(1);
    const [addMemberCoordinator, setAddMemberCoordinator] = useState(null);
    const [isAddFlow, setIsAddFlow] = useState(false);
    // inactive all team 
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [inactiveTeamConfirm, setInactiveTeamConfirm] = useState(false);
    const [endDate, setEndDate] = useState(null);

    // filter team member -right section
    const [teamMemberData, setTeamMemberData] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const [selectedProjectRole, setSelectedProjectRole] = useState([]);

    // inactive team member
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [teamMemberEndDate, setTeamMemberEndDate] = useState(null);

    // coordinator selection
    const [coordinatorModal, setCoordinatorModal] = useState(false);

    const column = [

        {
            field: 'Name',
            headerName: 'Employee Name',
            flex: 2,
        },
        {
            field: 'saplId',
            headerName: 'SAPL ID',
            flex: 1,
            valueGetter: (params) => {
                const name = params.row.Name || "";
                const parts = name.split("-");
                return parts.length > 1 ? parts[1] : "";
            }
        },
        {
            field: 'Department',
            headerName: 'Department',
            flex: 1,
        }
    ];
    // create team
    const handleCreateNew = () => {
        setCreateNew(true);
        setShowInactive(false);
        setIsFiltered(false);
    };
    const handleTeamName = (event) => {
        setTeamName(event.target.value);
    };

    const handleClientTeam = (newValue) => {
        setClientTeam(newValue?.ClientId || "");
    };
    const handleProjectTeam = (newValue) => {
        setProjectTeam(newValue?.ProjectId || "");
    };
    const handleExecutiveTeam = (newValue) => {
        const executive = newValue.map((item) => item.Id);
        setExecutiveTeam(executive);
        setSelectedMembers(
            newValue.map(item => ({
                ...item,
                isSaved: false,
                StartDate: Moment(new Date()).format('DD-MMM-YYYY'),
                Costing: item.Costing || 0,
                ProjectRole: item.ProjectRole || null
            }))
        );
    };
    const handleCoordinatorToggle = (clickedIndex) => {
        setSelectedMembers(prev =>
            prev.map((m, i) => {
                //  toggle clicked one
                if (i === clickedIndex) {
                    return {
                        ...m,
                        IsCoordinator: m.IsCoordinator === 1 ? 0 : 1
                    };
                }

                //  if clicked becomes 1 → others must be 0
                return {
                    ...m,
                    IsCoordinator: 0
                };
            })
        );
    };

    const handleDeleteClick = (index) => {
        setDeleteIndex(index);
        setEditIndex(null);
        setDeleteModal(true);
    };
    const handleDeleteCloseModal = () => {
        setDeleteModal(false)

    };
    const handleDelete = () => {
        if (deleteIndex === null) return;

        const updatedList = selectedMembers.filter((_, i) => i !== deleteIndex);

        setSelectedMembers(updatedList);
        setDeleteModal(false);
        setDeleteIndex(null);

        enqueueSnackbar("Team member removed successfully.", { variant: "success" });

        //  move back to DataGrid if empty
        if (updatedList.length === 0) {
            setStep(1);
            setCheckboxSelection([]); // optional reset
        }
    };
    const handleCreateTeam = () => {

        if (!teamName) {
            enqueueSnackbar("Team name is required.", { variant: "error" });
            return;
        }

        if (!clientTeam) {
            enqueueSnackbar("Client is required.", { variant: "error" });
            return;
        }

        if (!projectTeam) {
            enqueueSnackbar("Project is required.", { variant: "error" });
            return;
        }

        if (!selectedMembers || selectedMembers.length === 0) {
            enqueueSnackbar("At least one team member is required.", { variant: "error" });
            return;
        }

        const payload = {
            ProjectTeamMasterId: 0,
            ClientId: clientTeam || 0,
            ProjectId: projectTeam || 0,
            TeamName: teamName || "",
            IsActive: true,
            FromDate: Moment(new Date()).format('DD-MMM-YYYY') || "",
            EndDate: "",
            ProjectTeam: selectedMembers.map(item => ({
                ProjectTeamId: 0,
                ExecutiveId: item.Id,
                IsActive: true,
                IsCoOrdinator: item.IsCoordinator === 1,
                EndDate: "",
                Costing: Number(item.Costing) || 0,
                ProjectRole: item.ProjectRole?.Id || "",
                FromDate: Moment(item.StartDate).format('DD-MMM-YYYY') || ""
            }))

        };

        URLS.saveProjectTeamMaster(payload)
            .then((response) => {
                URLS.getTeamNames()
                    .then((response) => {
                        setSelectedTeam(Array.isArray(response.data) ? response.data : []);
                        handleCreateReset();
                    })
                    .catch(error => {
                        // On error
                        console.log(" Error ");
                    });
                enqueueSnackbar("Team created successfully", { variant: "success", });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
                enqueueSnackbar("Failed to create team", { variant: "error", });

            });
    };

    const handleReset = () => {
        setClient("");
        setTeam('');
        setExecutive('');
        setTeamName("");
        setExecutiveTeam("");
        setClientTeam("");
        setProjectTeam("");
        setCreateNew(false);
        setSelectedMembers([]);
        setTeamData([]);
        setTeamMemberData([]);
        setEndDate(null);
        setTeamMemberEndDate(null);
        setShowInactive(false);
        setSelectedCard(null);
    };
    const handleCreateReset = () => {
        setTeamName("");
        setClientTeam("");
        setProjectTeam("");
        setSelectedMembers([]);
        setTeamMemberData([]);
    };

    // All filter
    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
    };
    const handleTeam = (newValue) => {
        setTeam(newValue?.Id || "");
    };
    const handleExecutive = (newValue) => {
        setExecutive(newValue?.Id || "");
    };
    // globl filter
    const filterProjectTeamData = (
        payload,
        onSuccess,
        onError,
        showSuccessMsg = false,
        showErrorMsg = false
    ) => {
        setIsLoading(true);
        URLS.filterProjectTeamData(payload)
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                onSuccess && onSuccess(data);
                setIsLoading(false);

                if (showSuccessMsg) {
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                }
            })
            .catch((err) => {
                console.log("API Error", err);
                onError && onError();
                setIsLoading(false);
                if (showErrorMsg) {
                    enqueueSnackbar("Data not found", { variant: "error" });
                } loading
            });
    };

    const handleCardClick = (item) => {
        setSelectedCard(item);

        const payload = {
            ClientId: client || 0,
            ExecutiveId: executive || 0,
            ViewType: 2,
            ClientProjectId: item.TeamMasterId
        };
        filterProjectTeamData(
            payload,
            (data) => setTeamMemberData(data),
            () => setTeamMemberData([])
        );

    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };
    const handleSearchMemerExecutiveChange = (e) => {
        setSearchExecutiveMemberText(e.target.value);
    };
    const handleAddClick = () => {
        setAddModal(true);
        URLS.getExecutiveProjectTeamData({ ClientProjectId: selectedCard?.TeamMasterId })
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                setAddMemberData(data);
            })
            .catch((err) => {
                setAddMemberData([]);
                enqueueSnackbar("Data not found", { variant: "error" });
            });
    }
    const handleCloseAddModal = () => {
        setAddModal(false);

        setStep(1);
        setCheckboxSelection([]);
        setSelectedMembers([]);
        setEditIndex(null);
        setDeleteIndex(null);
        setDeleteModal(false);
    };
    const handleNext = () => {
        if (checkboxSelection.length === 0) {
            enqueueSnackbar("Please select at least one member.", { variant: "error" });
            return;
        }

        const selectedData = addMemberData.filter((row) =>
            checkboxSelection.includes(row.Id)
        );

        setSelectedMembers(selectedData);
        console.log("Selected Data:", selectedData);

        setStep(2);
    };
    const handleAddMember = () => {

        //  Merge existing team + newly selected members
        const allMembers = [
            ...teamMemberData,
            ...selectedMembers
        ];

        const payload = {
            ProjectTeamMasterId: selectedCard?.TeamMasterId || 0,
            ClientId: selectedCard?.ClientId || 0,
            ProjectId: selectedCard?.ProjectId || 0,
            TeamName: selectedCard?.TeamName || "",
            IsActive: selectedCard?.IsActive ?? true,
            FromDate: selectedCard?.FromDate
                ? Moment(selectedCard.FromDate).format('DD-MMM-YYYY')
                : "",
            EndDate: "",

            ProjectTeam: allMembers.map(item => ({
                ProjectTeamId: item.ProjectTeamId || 0,

                ExecutiveId: item.ExecutiveId || item.Id,

                IsActive: true,

                IsCoOrdinator:
                    item.IsCoOrdinator ?? (item.IsCoordinator === 1),

                EndDate: "",

                Costing: Number(item.Costing) || 0,

                ProjectRole:
                    typeof item.ProjectRole === "object"
                        ? item.ProjectRole?.Id
                        : item.ProjectRole || "",

                FromDate: item.StartDate
                    ? Moment(item.StartDate).format('DD-MMM-YYYY')
                    : item.FromDate
                        ? Moment(item.FromDate).format('DD-MMM-YYYY')
                        : Moment(new Date()).format('DD-MMM-YYYY')
            }))
        };

        const teamPayload = {
            ClientId: client || 0,
            ExecutiveId: executive || 0,
            ViewType: 1,
            ClientProjectId: team
        };

        const teamMemberPayload = {
            ClientId: selectedCard?.ClientId || 0,
            ExecutiveId: executive || 0,
            ViewType: 2,
            ClientProjectId: selectedCard?.TeamMasterId
        };

        console.log("FINAL PAYLOAD:", payload);

        URLS.saveProjectTeamMaster(payload)
            .then((response) => {
                console.log("team member response", response.data);

                filterProjectTeamData(
                    teamMemberPayload,
                    (data) => setTeamMemberData(data),
                    () => setTeamMemberData([])
                );

                filterProjectTeamData(
                    teamPayload,
                    (data) => setTeamData(data),
                    () => setTeamData([])
                );

                enqueueSnackbar("Team Member added successfully", { variant: 'success' });

                handleCloseAddModal();
            })
            .catch(() => {
                console.log("Error");
                enqueueSnackbar("Failed to add team member.", { variant: 'error' });
            });
    };

    const filteredTeamMembers = teamMemberData?.filter((item) =>
        item?.ExecutiveName?.toLowerCase().includes(searchText.toLowerCase())
    );
    const filteredAddExecutiveTeamMembers = addMemberData?.filter((item) =>
        item?.Name?.toLowerCase().includes(searchExecutiveMemberText.toLowerCase())
    );
    const handleTeamMemberCardClick = (item) => {
        setSelectedTeamMember(item)
    };

    const handleInactiveClick = (item) => {
        setShowInactive(true);
        setEndDate(null);
        handleCardClick(item)
    };
    const handleEndDate = (newValue) => {
        setEndDate(newValue);

    };

    // team member inactive
    const handleInactiveTeamMember = () => {
        setOpenDeleteModal(true);
    };

    const handleInactiveTeamMemberConfirmClick = () => {
        setTeamMemberEndDate(null);
        setOpenDeleteModal(false);
        setOpenDeleteConfirmModal(true);
    };

    const handleInactiveTeamMemberConfirm = (item) => {
        if (!teamMemberEndDate) {
            enqueueSnackbar("End date is required.", { variant: "error" });
            return;
        }
        console.log("team member>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", selectedTeamMember, item)
        const payload = {
            ProjectTeamMasterId: selectedCard?.TeamMasterId || 0,
            ClientId: selectedCard?.ClientId || 0,
            ProjectId: selectedCard?.ProjectId || 0,
            TeamName: selectedCard?.TeamName || "",
            IsActive: selectedCard?.IsActive || true,
            FromDate: selectedCard?.FromDate
                ? Moment(selectedCard.FromDate).format('DD-MMM-YYYY')
                : "",
            EndDate: "",
            ProjectTeam: [
                {
                    ProjectTeamId: item.ProjectTeamId,
                    ExecutiveId: item.ExecutiveId,
                    IsActive: false,
                    IsCoOrdinator: item.IsCoOrdinator ?? false,
                    EndDate: Moment(teamMemberEndDate).format('DD-MMM-YYYY') || "",
                    Costing: Number(item.Costing) || 0,
                    ProjectRole: item.ProjectRole || "",
                    FromDate: item.FromDate
                        ? Moment(item.FromDate).format('DD-MMM-YYYY')
                        : "",
                }
            ]
        };

        const teamPayload = {
            ClientId: client || 0,
            ExecutiveId: executive || 0,
            ViewType: 1,
            ClientProjectId: team
        };
        const teamMemberPayload = {
            ClientId: item.ClientId || 0,
            ExecutiveId: executive || 0,
            ViewType: 2,
            ClientProjectId: selectedCard?.TeamMasterId
        };
        console.log("item", item, payload)

        URLS.saveProjectTeamMaster(payload)
            .then((response) => {
                console.log("team member inactive", response.data, response)

                filterProjectTeamData(
                    teamMemberPayload,
                    (data) => setTeamMemberData(data),
                    () => setTeamMemberData([])
                );
                filterProjectTeamData(
                    teamPayload,
                    (data) => setTeamData(data),
                    () => setTeamData([])
                );

                setOpenDeleteConfirmModal(false);
                enqueueSnackbar("Team Member marked as inactive successfully", { variant: 'success' });

            })
            .catch(error => {
                // On error
                console.log(" Error ");
                setOpenDeleteConfirmModal(false);
                enqueueSnackbar("Failed to mark team member as inactive.", { variant: 'error' });

            });
    };

    const handleInactiveTeamMemberCancel = () => {
        setOpenDeleteConfirmModal(false);
        setTeamMemberEndDate(null);
    };
    const handleTeamMemberEndDate = (newValue) => {
        setTeamMemberEndDate(newValue)
    };
    // change team member coordinator
    const handleCoordinatorClick = (e, item) => {
        e.stopPropagation(); // ✅ prevent card click

        // optional: prevent clicking same coordinator
        if (item.IsCoOrdinator) return;
        setIsAddFlow(false);
        setSelectedTeamMember(item);
        setCoordinatorModal(true);
    };
    const handleAddCoordinatorClick = (e, index) => {
        e.stopPropagation(); // ✅ prevent card click

        const item = selectedMembers[index];

        if (item.IsCoordinator === 1) return;

        setIsAddFlow(true); // 👈 IMPORTANT
        setSelectedTeamMember({ ...item, index }); // store index
        setCoordinatorModal(true);
    };

    const existingCoordinator = isAddFlow
        ? selectedMembers.find(m => m.IsCoordinator === 1)
        || teamMemberData.find(m => m.IsCoOrdinator === true)
        : teamMemberData.find(m => m.IsCoOrdinator === true);

    const handleChangeCoordinator = () => {

        if (isAddFlow) {
            const selectedIndex = selectedTeamMember.index;

            // Set selected as coordinator
            setSelectedMembers(prev =>
                prev.map((m, i) => ({
                    ...m,
                    IsCoordinator: i === selectedIndex ? 1 : 0
                }))
            );

            // Remove coordinator from existing team
            setTeamMemberData(prev =>
                prev.map(m => ({
                    ...m,
                    IsCoOrdinator: false
                }))
            );

            setCoordinatorModal(false);
            setSelectedTeamMember(null);
            return;
        }

        const selected = selectedTeamMember;
        const selectedExecId = selected.ExecutiveId;

        const existingCoordinator = teamMemberData.find(
            m => m.IsCoOrdinator === true
        );

        const changedMembers = [];

        // Old → false
        if (existingCoordinator) {
            changedMembers.push({
                ...existingCoordinator,
                IsCoOrdinator: false
            });
        }

        // New → true
        changedMembers.push({
            ...selected,
            IsCoOrdinator: true
        });

        // Update UI
        setTeamMemberData(prev =>
            prev.map(m => ({
                ...m,
                IsCoOrdinator: m.ExecutiveId === selectedExecId
            }))
        );

        const payload = {
            ProjectTeamMasterId: selectedCard?.TeamMasterId || 0,
            ClientId: selectedCard?.ClientId || 0,
            ProjectId: selectedCard?.ProjectId || 0,
            TeamName: selectedCard?.TeamName || "",
            IsActive: true,
            FromDate: selectedCard?.FromDate
                ? Moment(selectedCard.FromDate).format('DD-MMM-YYYY')
                : "",
            EndDate: "",

            ProjectTeam: changedMembers.map(item => ({
                ProjectTeamId: item.ProjectTeamId || 0,
                ExecutiveId: item.ExecutiveId,
                IsActive: true,
                IsCoOrdinator: item.IsCoOrdinator,
                EndDate: "",
                Costing: Number(item.Costing) || 0,
                ProjectRole:
                    typeof item.ProjectRole === "object"
                        ? item.ProjectRole?.Id
                        : item.ProjectRole || "",
                FromDate: item?.FromDate
                    ? Moment(item.FromDate).format('DD-MMM-YYYY')
                    : "",
            }))
        };

        URLS.saveProjectTeamMaster(payload)
            .then(() => {
                enqueueSnackbar("Coordinator updated successfully", { variant: "success" });
                setCoordinatorModal(false);
                setSelectedTeamMember(null);
            })
            .catch(() => {
                enqueueSnackbar("Error updating coordinator", { variant: "error" });
            });
    };
    // team inactive
    const handleTeamInactiveClick = () => {
        if (!endDate) {
            enqueueSnackbar("End date is required.", { variant: "error" });
            return;
        }
        // setShowInactive(true);
        setInactiveTeamConfirm(true);
    };
    const handleInactiveTeamConfirm = (item) => {

        const payload = {
            ProjectTeamMasterId: item.TeamMasterId || 0,
            ClientId: item.ClientId || 0,
            ProjectId: item.ProjectId || 0,
            TeamName: item.TeamName || "",
            IsActive: false,
            FromDate: item.FromDate
                ? Moment(item.FromDate).format('DD-MMM-YYYY')
                : "",
            EndDate: endDate ? Moment(endDate).format('DD-MMM-YYYY') : "",
            ProjectTeam: teamMemberData.map(item => ({
                ProjectTeamId: item.ProjectTeamId,
                ExecutiveId: item.ExecutiveId,
                IsActive: false,
                IsCoOrdinator: item.IsCoOrdinator || false,
                EndDate: Moment(endDate).format('DD-MMM-YYYY') || "",
                Costing: Number(item.Costing) || 0,
                ProjectRole: item.ProjectRole || "",
                FromDate: item.FromDate
                    ? Moment(item.FromDate).format('DD-MMM-YYYY')
                    : "",
            }))

        };
        console.log("item", item, payload)
        const teamPayload = {
            ClientId: item.ClientId || 0,
            ExecutiveId: executive || 0,
            ViewType: 1,
            ClientProjectId: selectedCard?.TeamMasterId
        };
        const teamMemberPayload = {
            ClientId: item.ClientId || 0,
            ExecutiveId: executive || 0,
            ViewType: 2,
            ClientProjectId: selectedCard?.TeamMasterId
        };
        URLS.saveProjectTeamMaster(payload)
            .then((response) => {
                console.log("team inactive>>>>>>>>>>>>>>", response.data, response)

                URLS.getTeamNames()
                    .then((response) => {
                        setSelectedTeam(Array.isArray(response.data) ? response.data : []);

                    })
                    .catch(error => {
                        // On error
                        console.log(" Error ");
                    });
                handleReset();

                setInactiveTeamConfirm(false);
                enqueueSnackbar("Team marked as inactive successfully", { variant: 'success' });

            })
            .catch(error => {
                // On error
                setInactiveTeamConfirm(false);

                enqueueSnackbar("Failed to mark team as inactive.", { variant: 'error' });


                console.log(" Error ");
            });
    };

    const handleCancelInactiveCardClick = () => {
        setShowInactive(false);
    };

    const handleInactiveTeamCancelClick = () => {
        setInactiveTeamConfirm(false);

    };

    const onFilterClick = () => {
        setIsFiltered(true);
        setShowInactive(false);
        setCreateNew(false);
        setSelectedCard(null);
        setTeamMemberData([]);

        const payload = {
            ClientId: client || 0,
            ExecutiveId: executive || 0,
            ViewType: 1,
            ClientProjectId: team
        };
        filterProjectTeamData(
            payload,
            (data) => setTeamData(data),
            () => setTeamData([]),
            true,
            true
        );

    };
    // edit team member
    const handleProjectRole = (value, index) => {
        setSelectedMembers(prev =>
            prev.map((m, i) =>
                i === index ? { ...m, ProjectRole: value } : m
            )
        );
    };
    const handleCosting = (e, index) => {
        const value = e.target.value;

        setSelectedMembers(prev =>
            prev.map((m, i) =>
                i === index ? { ...m, Costing: value } : m
            )
        );
    };
    const handleFromDate = (date, index) => {
        setSelectedMembers(prev =>
            prev.map((m, i) =>
                i === index
                    ? { ...m, StartDate: date || Moment(new Date()).format('DD-MMM-YYYY') } // ✅ use selected date
                    : m
            )
        );
    };
    const handleSaveChanges = (index) => {
        const item = selectedMembers[index];
        setSelectedMembers(prev =>
            prev.map((m, i) =>
                i === index ? { ...m, isSaved: true } : m
            )
        );
        setEditIndex(null);
    };
    const exportTeamData = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "TeamMasterId",
            "ProjectId",
            "EndDate",
            "IsActive",
            "FromDate",

        ];

        // Check if reports are available
        if (!teamData || teamData.length === 0) {
            enqueueSnackbar("No team data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(teamData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );

        const dataToExport = teamData.map((row) => headers.map(header => row[header]));

        const dataWithHeaders = [headers, ...dataToExport];
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `ProjectTeamData_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Team Data successfully.", { variant: "success" });
    };

    const exportTeamMemberData = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "ClientProjectId",
            "ProjectTeamId",
            "Costing",
            "ProjectRole",
            "FromDate",
            "EndDate",
            "IsActive",
            "Period",
            "TotalDays",

        ];

        // Check if reports are available
        if (!teamMemberData || teamMemberData.length === 0) {
            enqueueSnackbar("No team data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(teamMemberData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );

        const dataToExport = teamMemberData.map((row) => headers.map(header => row[header]));

        const dataWithHeaders = [headers, ...dataToExport];
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `ProjectTeamMemberData_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Team Member Data successfully.", { variant: "success" });
    };
    useEffect(() => {

        URLS.getTeamNames()
            .then((response) => {
                setSelectedTeam(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
                setSelectedClientTeam(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.projectList()
            .then((response) => {
                setSelectedProjectTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives(userClientId)
            .then((response) => {
                setSelectedExecutive(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        const payloadExecutive = { ExecutiveLoginId: 0 };
        URLS.getExecutiveInfo(payloadExecutive)
            .then((response) => {
                setSelectedExecutiveTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log("Error");
            });
        URLS.getRoles()
            .then((response) => {
                setSelectedProjectRole(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    }, []);

    useEffect(() => {
        handleReset();
    }, [location.key]);

    const isTeamExist = teamData?.length > 0;
    const [editData, setEditData] = useState({});

    console.log("isTeamExist", isTeamExist, selectedMembers, createNew, "selectedCard", selectedCard, "teamData", teamData,
        "teamMemberData", teamMemberData, "selectedTeamMember", selectedTeamMember)
    return (
        <Box sx={{
            display: 'flex', gap: 2, px: 1.5, overflow: 'hidden'
        }}>
            <Box sx={{ flex: 5.2, }}>
                <Card
                    sx={{
                        p: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        border: '1px solid #E5E5E5',
                        boxShadow: 'none',
                        borderRadius: '12px',
                        maxHeight: '80vh',
                        height: 'auto'
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            p: 1,
                            borderBottom: '1px solid #E5E5E5',
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {createNew ? "Create New Team" : "Project Team"}
                            </Typography>
                            <Typography sx={{ color: '#94A3B8', fontSize: '12px' }}>
                                {createNew ? "Fill below details to create new team" : "Search or create new team"}

                            </Typography>
                        </Box>
                        <Stack direction="row" spacing={1}>

                            {!createNew && (
                                <>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddIcon />}
                                        onClick={handleCreateNew}
                                        sx={{
                                            textTransform: "none",
                                            height: '34px',

                                        }}
                                    >
                                        Create New
                                    </Button>

                                    <Tooltip title="Export To Excel" >
                                        <IconButton
                                            sx={{
                                                width: 38,
                                                height: 35,
                                                backgroundColor: "#FFFFFF",
                                                border: "1px solid #E0E0E0",
                                                borderRadius: "8px",
                                                color: '#ABABAB',
                                                "&:hover": {
                                                    backgroundColor: '#2E7D32', // primary color fill
                                                    color: "#fff",                                           // text white
                                                    borderColor: '1px solid #2E7D32',
                                                },
                                            }}
                                            onClick={exportTeamData}
                                        >
                                            <FileDownloadOutlinedIcon sx={{ width: 20, height: 20 }} />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}

                        </Stack>
                    </Box>

                    {/* ================= CREATE NEW ================= */}
                    {createNew && (
                        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                            <Box sx={{ px: 2, py: 1, flex: 1, overflowY: "auto" }}>
                                <Stack direction="column" spacing={1.5}>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Team Name</FormLabel>
                                        <TextField
                                            placeholder="Enter unique team name"
                                            value={teamName} // replace with state
                                            onChange={handleTeamName} // replace with handler
                                            size="small" fullWidth
                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Client</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClientTeam.find((option) => option.ClientId === clientTeam) || ""}
                                            onChange={(_, newValue) => handleClientTeam(newValue)}
                                            options={selectedClientTeam}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Clients" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />

                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Project</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="project"
                                            value={selectedProjectTeam.find((item) => item.ProjectId === projectTeam) || null}
                                            onChange={(_, newValue) => handleProjectTeam(newValue)}
                                            options={selectedProjectTeam}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ProjectId === value.ProjectId}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ProjectId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Project" />}

                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel
                                            sx={{
                                                mb: 0.5,
                                                '&::after': {
                                                    content: '" *"',
                                                    color: 'red',
                                                },
                                            }}
                                        >
                                            Add Team Member
                                        </FormLabel>
                                        <Autocomplete
                                            multiple
                                            fullWidth
                                            size="small"
                                            options={selectedExecutiveTeam}
                                            value={selectedMembers}
                                            onChange={(_, newValue) => handleExecutiveTeam(newValue)}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderTags={(value) =>
                                                value.length > 0 ? `${value.length} Selected` : ""
                                            }

                                            renderOption={(props, option, { selected }) => (
                                                <li {...props} key={option.Id}>
                                                    <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                    {option.Name}
                                                </li>
                                            )}

                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Executive" />
                                            )}
                                        />
                                    </FormControl>

                                </Stack>
                            </Box>
                            <Box
                                sx={{
                                    borderTop: "1px solid #E5E5E5",
                                    p: 1.5,
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff"
                                }}
                            >
                                <Stack direction="row" spacing={1} justifyContent="flex-end">

                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                        onClick={handleReset}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="outlined" color="inherit" onClick={handleCreateReset}>
                                        Reset
                                    </Button>

                                    <LoadingButton
                                        size="medium"
                                        variant="contained" color='primary'
                                        loading={isLoading}
                                        onClick={handleCreateTeam}

                                    >
                                        Create Team
                                    </LoadingButton>

                                </Stack>
                            </Box>
                        </Box>
                    )}

                    {!createNew && (
                        <>
                            <Box sx={{ p: 1 }}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Clients" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />

                                    </FormControl>
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="team"
                                            value={selectedTeam.find((item) => item.Id === team) || ""}
                                            onChange={(_, newValue) => handleTeam(newValue)}
                                            options={selectedTeam}
                                            getOptionLabel={(option) => option.TeamName || ""}
                                            isOptionEqualToValue={(o, v) => o.Id === v.Id}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Teams" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.TeamName}
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth sx={{ flex: 1 }} >
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="executive"
                                            value={selectedExecutive.find((option) => option.Id === executive) || ""}
                                            onChange={(_, newValue) => handleExecutive(newValue)}
                                            options={selectedExecutive}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Executive" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                    <Tooltip title="Filter">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={onFilterClick}
                                            sx={{ minWidth: '40px' }}
                                        >
                                            <Icon icon="ic:outline-filter-alt" width="20" height="20" sx={{ mr: '5px' }} />
                                        </Button>
                                    </Tooltip>

                                    {/* Reset */}
                                    <Tooltip title="Reset">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={handleReset}
                                            sx={{ minWidth: '40px' }}

                                        >
                                            <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                                        </Button>
                                    </Tooltip>

                                </Stack>
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',

                                }}
                            >
                                {/* card select*/}
                                {showInactive && selectedCard ?
                                    (
                                        <>
                                            <Box sx={{ p: 1 }}>
                                                <Card
                                                    sx={{
                                                        p: 1,
                                                        border: "1px solid #E5E7EB",
                                                        borderRadius: "14px",
                                                        boxShadow: "none",

                                                    }}
                                                >
                                                    {/* HEADER */}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        borderBottom="1px solid #E5E7EB"
                                                        pb={1}

                                                    >
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            <Typography fontWeight={500} fontSize="16px">
                                                                {selectedCard.TeamName}
                                                            </Typography>

                                                            {/* Active Status */}
                                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                                <Box
                                                                    sx={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: "50%",
                                                                        background: "#1AE16A",
                                                                    }}
                                                                />
                                                                <Typography fontSize="12px" color="#04A043">
                                                                    Active
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        {/* DATE */}
                                                        <Typography>
                                                            {selectedCard?.FromDate
                                                                ? `${Moment(selectedCard.FromDate).format('DD-MMM-YYYY')} - ${selectedCard?.EndDate
                                                                    ? Moment(selectedCard.EndDate).format('DD-MMM-YYYY')
                                                                    : "Present"
                                                                }`
                                                                : "Present"}
                                                        </Typography>
                                                    </Box>

                                                    {/* DETAILS */}
                                                    <Grid container spacing={1}>
                                                        {/* Client ID */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                    Client ID
                                                                </Typography>
                                                                <Typography >
                                                                    {selectedCard.ClientId}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Client Name */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                    Client Name
                                                                </Typography>
                                                                <Typography >
                                                                    {selectedCard.ClientName}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Client Alies */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                    Client Alies
                                                                </Typography>
                                                                <Typography >
                                                                    {selectedCard.ClientAlies}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Project */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                    Project
                                                                </Typography>
                                                                <Typography>
                                                                    {selectedCard.ProjectName}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                    {/* FOOTER */}
                                                    <Box
                                                        pt={1}
                                                        borderTop="1px solid #E5E7EB"
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                    >
                                                        <Typography >
                                                            {selectedCard.TeamMemberCount || 0} Team Members

                                                        </Typography>

                                                    </Box>

                                                </Card>
                                                <Box sx={{ p: 1 }}>

                                                    <FormControl size="small" fullWidth>
                                                        <FormLabel sx={{
                                                            mb: 0.5,
                                                            '&::after': {
                                                                content: '" *"',
                                                                color: 'red',
                                                            },
                                                        }}>Set End Date</FormLabel>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DesktopDatePicker
                                                                inputFormat="dd/MMM/yyyy"
                                                                value={endDate ? Moment(endDate, 'DD-MMM-YYYY').toDate() : null}
                                                                onChange={handleEndDate}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        fullWidth
                                                                        size="small"
                                                                        error={false}
                                                                        inputProps={{
                                                                            ...params.inputProps,
                                                                            placeholder: endDate ? params.inputProps?.placeholder : "Present"
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                    <Box sx={{ py: 1 }}>
                                                        <Card
                                                            sx={{
                                                                p: 1,
                                                                border: '1px solid #FFEBD4',
                                                                borderRadius: '10px',
                                                                boxShadow: 'none',
                                                                backgroundColor: '#FFF7ED',
                                                            }}
                                                        >
                                                            <Box>
                                                                {/* First line: icon + Important */}
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        mb: 0.5
                                                                    }}
                                                                >
                                                                    <WarningAmberOutlinedIcon
                                                                        sx={{
                                                                            mr: 1,
                                                                            width: 20,
                                                                            height: 20,
                                                                            color: "#F54A00",
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        fontSize="14px"
                                                                        fontWeight="500"
                                                                        color="#9F2D00"
                                                                    >
                                                                        Important
                                                                    </Typography>
                                                                </Box>

                                                                {/* Second line: message */}
                                                                <Typography color="#9F2D00" fontSize="14px">
                                                                    Marking this team as inactive will also mark all {selectedCard.TeamMemberCount} active members as inactive
                                                                    with the same end date
                                                                </Typography>
                                                            </Box>
                                                        </Card>
                                                    </Box >
                                                </Box>
                                            </Box>
                                            <Modal open={inactiveTeamConfirm} onClose={handleInactiveTeamCancelClick}>
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        width: 444,
                                                        bgcolor: "#fff",
                                                        borderRadius: "8px",
                                                        boxShadow: "none",
                                                        p: 1,
                                                        // height: 138
                                                    }}
                                                >
                                                    {/* MESSAGE */}
                                                    <Typography fontSize="14px" fontWeight="600">
                                                        Are you sure you want to inactive the team{" "}
                                                        <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                                            “{selectedCard?.TeamName}”?
                                                        </span>{" "}
                                                        This will also inactive all team members.
                                                    </Typography>
                                                    {/* ACTIONS */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            gap: 2,
                                                            mt: 3,
                                                        }}
                                                    >
                                                        {/* NO */}
                                                        <Typography
                                                            onClick={handleInactiveTeamCancelClick}
                                                            sx={{
                                                                cursor: "pointer",
                                                                textDecoration: "underline",
                                                                fontWeight: 600,
                                                                color: "#000",
                                                                fontSize: '14px'
                                                            }}
                                                        >
                                                            Cancel
                                                        </Typography>

                                                        {/* YES */}
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleInactiveTeamConfirm(selectedCard)}
                                                            sx={{
                                                                backgroundColor: "#FF2B2B",
                                                                borderRadius: "8px",
                                                                px: 3,
                                                                textTransform: "none",
                                                                fontWeight: 600,
                                                                "&:hover": {
                                                                    backgroundColor: "#FF2B2B",
                                                                },
                                                                fontSize: '14px'

                                                            }}
                                                        >
                                                            Confirm
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Modal>

                                        </>
                                    )
                                    : isFiltered &&
                                    (
                                        teamData?.length > 0 && teamData?.map((item, index) => {
                                            const isSelected = selectedCard?.TeamMasterId === item?.TeamMasterId;
                                            return (
                                                <Box key={item.id || index} sx={{ p: 1 }}>
                                                    <Card
                                                        sx={{
                                                            p: 1,
                                                            border: isSelected
                                                                ? "1px solid #3C97FF"   //  selected
                                                                : "1px solid #E5E7EB", // default
                                                            borderRadius: "14px",
                                                            boxShadow: "none",
                                                        }}
                                                        onClick={() => handleCardClick(item)}

                                                    >
                                                        {/* HEADER */}
                                                        <Box
                                                            display="flex"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                            borderBottom="1px solid #E5E7EB"
                                                            pb={1}

                                                        >
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <Typography fontWeight={500} fontSize="16px">
                                                                    {item.TeamName}
                                                                </Typography>

                                                                {/* Active Status */}
                                                                <Box display="flex" alignItems="center" gap={0.5}>
                                                                    <Box
                                                                        sx={{
                                                                            width: 8,
                                                                            height: 8,
                                                                            borderRadius: "50%",
                                                                            background: "#1AE16A",
                                                                        }}
                                                                    />
                                                                    <Typography fontSize="12px" color="#04A043">
                                                                        Active
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            {/* DATE */}
                                                            <Typography>
                                                                {item?.FromDate
                                                                    ? `${Moment(item.FromDate).format('DD-MMM-YYYY')} - ${item?.EndDate
                                                                        ? Moment(item.EndDate).format('DD-MMM-YYYY')
                                                                        : "Present"
                                                                    }`
                                                                    : "Present"}
                                                            </Typography>

                                                        </Box>

                                                        {/* DETAILS */}
                                                        <Grid container spacing={1}>
                                                            {/* Client ID */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ px: 2, py: 1 }}>
                                                                    <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                        Client ID
                                                                    </Typography>
                                                                    <Typography >
                                                                        {item.ClientId}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            {/* Client Name */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ px: 2, py: 1 }}>
                                                                    <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                        Client Name
                                                                    </Typography>
                                                                    <Typography >
                                                                        {item.ClientName}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            {/* Client Alies */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ px: 2, py: 1 }}>
                                                                    <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                        Client Alies
                                                                    </Typography>
                                                                    <Typography >
                                                                        {item.ClientAlies}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            {/* Project */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ px: 2, py: 1 }}>
                                                                    <Typography fontSize="10px" color="#9A9A9A" fontWeight={500}>
                                                                        Project
                                                                    </Typography>
                                                                    <Typography>
                                                                        {item.ProjectName}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>


                                                        {/* FOOTER */}
                                                        <Box
                                                            pt={1}
                                                            borderTop="1px solid #E5E7EB"
                                                            display="flex"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                        >
                                                            <Typography >
                                                                {item.TeamMemberCount || 0} Team Members

                                                            </Typography>
                                                            {/*{!showInactive && (*/}
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    background: "#D4183D",
                                                                    borderRadius: "10px",
                                                                    textTransform: "none",
                                                                    fontWeight: 600,
                                                                    px: 2.5,
                                                                    width: '140px',
                                                                    height: '34px',
                                                                    "&:hover": {
                                                                        backgroundColor: "#D4183D",
                                                                        color: "#FFFFFF",
                                                                    },
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();   // optional but good
                                                                    handleInactiveClick(item);  // ✅ now runs only on click
                                                                }}
                                                            >
                                                                Make Inactive
                                                            </Button>
                                                            {/*)}*/}
                                                        </Box>
                                                    </Card>

                                                </Box>
                                            )
                                        }


                                        )

                                    )
                                }

                            </Box>
                        </>
                    )}

                    {showInactive && !createNew && (
                        <Box
                            sx={{
                                borderTop: "1px solid #E5E5E5",
                                p: 1.5,
                                bottom: 0,
                                background: "#fff"
                            }}
                        >
                            <Stack direction="row" spacing={1} justifyContent="flex-end">

                                <Button
                                    variant="outlined"
                                    color="inherit"
                                    onClick={handleCancelInactiveCardClick}
                                    sx={{ width: '120px', color: "#374151", background: "#F3F4F6", border: "1px solid #D1D5DB" }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: "#D4183D",
                                        borderRadius: "10px",
                                        textTransform: "none",
                                        fontWeight: 600,
                                        px: 2.5,
                                        width: '140px',
                                        height: '34px',
                                        "&:hover": {
                                            backgroundColor: "#D4183D",
                                            color: "#FFFFFF",
                                        },
                                    }}
                                    onClick={handleTeamInactiveClick}

                                >
                                    Make Inactive
                                </Button>
                            </Stack>
                        </Box>
                    )}

                </Card>
            </Box >

            <Box sx={{ flex: 4.8, position: "relative", display: "flex", height: "468px" }}>
                <Card
                    sx={{
                        p: 0,
                        borderRadius: "12px",
                        width: "100%",
                        border: "1px solid #E5E5E5",
                        boxShadow: "none",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            p: 1,
                            borderBottom: "1px solid #E5E5E5",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>

                                {createNew ? `Team Members Preview` : `Team Members`}
                            </Typography>

                            <Typography sx={{ color: "#94A3B8", fontSize: "12px" }}>
                                {createNew ? `Members added (${selectedMembers?.length || 0})` : `Search or create new team`}
                            </Typography>
                        </Box>

                        {selectedCard && !createNew && (
                            <Stack direction="row" spacing={1}>
                                <TextField
                                    size="small"
                                    placeholder="Search By Executive"
                                    sx={{ width: 220 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ManageSearchOutlinedIcon sx={{ color: '#989898' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={searchText}
                                    onChange={handleSearchChange}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<Icon icon="mdi:plus" />}
                                    sx={{ width: '120px', borderRadius: '10px' }}
                                    onClick={handleAddClick}
                                >
                                    Add New
                                </Button>
                                <Tooltip title="Export To Excel" >

                                    <IconButton
                                        sx={{
                                            width: 38,
                                            height: 35,
                                            backgroundColor: "#FFFFFF",
                                            border: "1px solid #E0E0E0",
                                            borderRadius: "8px",
                                            color: '#ABABAB',
                                            "&:hover": {
                                                backgroundColor: '#2E7D32', // primary color fill
                                                color: "#fff",                                           // text white
                                                borderColor: '1px solid #2E7D32',
                                            },
                                        }}
                                        onClick={exportTeamMemberData}
                                    >
                                        <FileDownloadOutlinedIcon sx={{ width: 20, height: 20 }} />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        )}

                    </Box>

                    {/* BODY */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            p: 1,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {/* CASE 1 : No Team Selected */}
                        {!createNew && !selectedCard && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography fontWeight={600} fontSize={14}>
                                    Project Team not selected
                                </Typography>
                                <Typography fontSize={12} color="#717182">
                                    Select a team from the Project team list to view its member.
                                </Typography>
                            </Box>
                        )}

                        {/* CASE 2 : Create New but no member */}
                        {createNew && selectedMembers?.length === 0 && (
                            <Box
                                sx={{
                                    height: '68vh',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography fontWeight={500} fontSize={16} color='#928A8A'>
                                    No team member added yet
                                </Typography>
                                <Typography fontSize={12} color="#928A8A">
                                    Select team members from the dropdown to see them listed here.
                                </Typography>
                            </Box>
                        )}

                        {/* CASE 3 : Show Members */}
                        {/* ✅ WHEN createNew = false → OLD UI */}
                        {!createNew && selectedCard && (
                            <Box width="100%">
                                {filteredTeamMembers.length === 0 ? (

                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "150px"
                                        }}
                                    >
                                        <Typography sx={{ color: "#717182", fontSize: 14 }}>
                                            No Executive found
                                        </Typography>
                                    </Box>
                                ) : (

                                    filteredTeamMembers.map((item, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                mb: 1,
                                                p: 2,
                                                borderRadius: "15px",
                                                border: "1px solid #E5E5E5",
                                                boxShadow: "none",
                                            }}
                                            onClick={() => handleTeamMemberCardClick(item)}

                                        >
                                            <Stack direction="row" justifyContent="space-between">
                                                <Box>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <Typography fontWeight={500} fontSize={14}>
                                                            {item.ExecutiveName || ""}{" "}
                                                            <Box
                                                                component="span"
                                                                sx={{ color: "", fontWeight: 400 }}
                                                            >
                                                                ({item.ExecutiveERPCode || ""}) ({item.ExecutiveId})
                                                            </Box>
                                                        </Typography>

                                                        <Chip
                                                            label={item.Department || ""}
                                                            size="small"
                                                            sx={{
                                                                border: "1px solid #E5E5E5",
                                                                borderRadius: "6px",
                                                                fontSize: "10px",
                                                                fontWeight: 500,
                                                                color: "#4A4949"
                                                            }}
                                                        />

                                                        {item.IsCoOrdinator === true && (
                                                            <Chip
                                                                label="Coordinator"
                                                                size="small"
                                                                sx={{ bgcolor: "#121212", color: "#fff" }}
                                                            />
                                                        )}
                                                    </Stack>

                                                    <Typography sx={{ color: "#717182", mt: 0.5 }}>

                                                        <Tooltip title="Client Name" arrow>
                                                            <span>{item.ClientName || "-"}</span>
                                                        </Tooltip>

                                                        {" • "}

                                                        <Tooltip title="Client Id" arrow>
                                                            <span>{item.ClientId || "-"}</span>
                                                        </Tooltip>

                                                        {" • "}

                                                        <Tooltip title="Client Alias" arrow>
                                                            <span>{item.ClientAlies || "-"}</span>
                                                        </Tooltip>

                                                        {" • "}

                                                        <Tooltip title="Project Name" arrow>
                                                            <span>{item.Project || "-"}</span>
                                                        </Tooltip>

                                                    </Typography>

                                                    <Typography sx={{ mt: 0.5, fontSize: 12 }}>
                                                        <Box component="span" sx={{ color: "#717182" }}>
                                                            Period:
                                                        </Box>{" "}
                                                        <Box component="span" sx={{ color: "#3D3838", fontSize: 12 }}>
                                                            {item.FromDate
                                                                ? Moment(item.FromDate).format('DD-MMM-YYYY')
                                                                : ""}{" "}
                                                            →{" "}
                                                            {item.EndDate
                                                                ? Moment(item.EndDate).format('DD-MMM-YYYY')
                                                                : "Present"}
                                                        </Box>{" "}
                                                        <Box component="span" sx={{ color: "#717182", fontSize: 12 }}>
                                                            ({item.TotalDays || ""} days)
                                                        </Box>
                                                    </Typography>
                                                </Box>

                                                <Stack direction="row" spacing={1}>
                                                    <Icon
                                                        icon={
                                                            item.IsCoOrdinator === true
                                                                ? "material-symbols:person-cancel-outline-rounded"
                                                                : "material-symbols:person-check-outline-rounded"
                                                        }
                                                        width={20}
                                                        style={{
                                                            color: item.IsCoOrdinator === true ? "#D4183D" : "#0062FF",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={(e) => handleCoordinatorClick(e, item)}
                                                    />
                                                    <Icon
                                                        icon="material-symbols:person-off-outline-rounded"
                                                        color="#374151"
                                                        width={20}
                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={handleInactiveTeamMember}
                                                    />
                                                </Stack>
                                            </Stack>
                                        </Card>
                                    ))
                                )}
                            </Box>

                        )}

                        <Modal open={addModal} onClose={handleCloseAddModal}>
                            <Box
                                sx={{
                                    ...modalStyle,
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "80vh",
                                    overflow: "hidden"
                                }}
                            >
                                {/* HEADER */}
                                <Box
                                    sx={{
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 10,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 16px',
                                        borderBottom: '1px solid #D1D5DB',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Typography fontSize={14} fontWeight={600}>
                                        Add Member
                                    </Typography>

                                    <Box
                                        onClick={handleCloseAddModal}
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#F1F1F1",
                                            border: "1px solid #EDEDED",
                                            borderRadius: "6px",
                                            cursor: "pointer"
                                        }}
                                    >
                                        <Icon icon="material-symbols:close-rounded" width={18} />
                                    </Box>
                                </Box>

                                {/* BODY (SCROLLABLE) */}
                                <Box sx={{ flex: 1, overflow: 'auto', px: 2, py: 1.5 }}>
                                    {step === 1 ? (
                                        <Box sx={{ height: '100%', width: '100%' }}>
                                            <TextField
                                                size="small"
                                                placeholder="Search By Executive Name"
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <ManageSearchOutlinedIcon sx={{ color: '#989898' }} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={searchExecutiveMemberText}
                                                onChange={handleSearchMemerExecutiveChange}
                                            />
                                            <DataGrid
                                                rows={filteredAddExecutiveTeamMembers}
                                                columns={column}
                                                density="compact"
                                                checkboxSelection
                                                disableRowSelectionOnClick
                                                getRowId={(row) => row.Id}
                                                selectionModel={checkboxSelection}
                                                onSelectionModelChange={(newSelection) => {
                                                    console.log("Selected IDs:", newSelection); // 👈 check this
                                                    setCheckboxSelection(newSelection);
                                                }}
                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                pagination
                                                paginationMode="client"
                                                rowsPerPageOptions={[25, 50, 100]}
                                                pageSize={pageSize}
                                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                                getRowHeight={() => 'auto'}
                                            />
                                        </Box>
                                    ) : (
                                        <>
                                            <Box width="100%">
                                                {selectedMembers.map((item, index) => {
                                                    const isEdit = editIndex === index;

                                                    return (
                                                        <Card
                                                            key={index}
                                                            sx={{
                                                                mb: 1,
                                                                p: 1,
                                                                borderRadius: "15px",
                                                                border: "1px solid #E5E5E5",
                                                                boxShadow: "none",
                                                            }}
                                                        >
                                                            {!isEdit ? (
                                                                //  PREVIEW MODE 
                                                                <Stack direction="row" justifyContent="space-between">
                                                                    <Box>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <Typography fontWeight={500} fontSize={14}>
                                                                                {(item.Name || "").split("-")[0]}{" "}
                                                                                <Box component="span" sx={{ color: "#717182", fontWeight: 400 }}>
                                                                                    ({(item.Name || "").split("-")[1] || ""}) ({item.Id})
                                                                                </Box>
                                                                            </Typography>

                                                                            <Chip
                                                                                label={item.Department || ""}
                                                                                size="small"
                                                                                sx={{
                                                                                    border: "1px solid #E5E5E5",
                                                                                    borderRadius: "6px",
                                                                                    fontSize: "10px",
                                                                                    fontWeight: 500,
                                                                                    color: "#4A4949"
                                                                                }}
                                                                            />
                                                                            {item.IsCoordinator === 1 && (
                                                                                <Chip
                                                                                    label="Coordinator"
                                                                                    size="small"
                                                                                    sx={{ bgcolor: "#121212", color: "#fff" }}
                                                                                />
                                                                            )}
                                                                        </Stack>

                                                                        <Typography sx={{ color: "#717182", mt: 0.5 }}>
                                                                            {item.isSaved ? item.ProjectRole?.Name : item.Designation} •
                                                                            {item.StartDate
                                                                                ? Moment(item.StartDate).format('DD-MMM-YYYY')
                                                                                : Moment().format('DD-MMM-YYYY')
                                                                            } •
                                                                            Costing: {item.isSaved ? item.Costing || 0 : 0}
                                                                        </Typography>
                                                                    </Box>

                                                                    {/* ACTIONS */}
                                                                    <Stack direction="row" spacing={1}>
                                                                        <Icon
                                                                            icon="material-symbols:border-color-outline"
                                                                            width={20}
                                                                            color="#374151"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                setEditIndex(index);
                                                                                setEditData({
                                                                                    role: item.Role || "",
                                                                                    date: item.StartDate || "",
                                                                                    costing: item.Costing || "",
                                                                                });
                                                                            }}
                                                                        />
                                                                        <Icon
                                                                            icon={
                                                                                item.IsCoordinator === 1
                                                                                    ? "material-symbols:person-cancel-outline-rounded"
                                                                                    : "material-symbols:person-check-outline-rounded"
                                                                            }
                                                                            width={20}
                                                                            style={{
                                                                                color: item.IsCoordinator === 1 ? "#D4183D" : "#0062FF",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={(e) => handleAddCoordinatorClick(e, index)}
                                                                        />
                                                                        <Box
                                                                            sx={{
                                                                                bgcolor: "#D93A46",
                                                                                width: 20,
                                                                                height: 20,
                                                                                borderRadius: "5px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                            onClick={() => handleDeleteClick(index)}

                                                                        >
                                                                            <Icon icon="material-symbols:delete-outline-rounded" color="#fff" width={14} />
                                                                        </Box>
                                                                    </Stack>
                                                                </Stack>
                                                            ) : (
                                                                // ✅ EDIT MODE (SECOND IMAGE)
                                                                <Box>
                                                                    {/* TOP ROW */}
                                                                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>

                                                                        <Typography fontWeight={500} fontSize={14}>
                                                                            {(item.Name || "").split("-")[0]}{" "}
                                                                            <Box component="span" sx={{ color: "#717182", fontWeight: 400 }}>
                                                                                ({(item.Name || "").split("-")[1] || ""}) ({item.Id})
                                                                            </Box>
                                                                        </Typography>
                                                                        <Chip label={item.Department} size="small" />
                                                                        {item.IsCoordinator === 1 && (
                                                                            <Chip
                                                                                label="Coordinator"
                                                                                size="small"
                                                                                sx={{ bgcolor: "#121212", color: "#fff" }}
                                                                            />
                                                                        )}
                                                                        {/* ACTIONS */}
                                                                        <Stack direction="row" spacing={1}>
                                                                            <Icon
                                                                                icon={
                                                                                    item.IsCoordinator === 1
                                                                                        ? "material-symbols:person-cancel-outline-rounded"
                                                                                        : "material-symbols:person-check-outline-rounded"
                                                                                }
                                                                                width={20}
                                                                                style={{
                                                                                    color: item.IsCoordinator === 1 ? "#D4183D" : "#0062FF",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                onClick={() => handleCoordinatorToggle(index)}
                                                                            />
                                                                            <Box
                                                                                sx={{
                                                                                    bgcolor: "#D93A46",
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    borderRadius: "5px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                }}
                                                                                onClick={() => handleDeleteClick(index)}

                                                                            >
                                                                                <Icon icon="material-symbols:delete-outline-rounded" color="#fff" width={14} />
                                                                            </Box>
                                                                        </Stack>
                                                                    </Stack>

                                                                    {/* EDIT FIELDS */}
                                                                    <Stack direction="row" spacing={1} alignItems="center">

                                                                        <FormControl size="small" fullWidth sx={{ width: 130 }}>

                                                                            <Autocomplete
                                                                                fullWidth
                                                                                limitTags={2}
                                                                                size="small"
                                                                                id="role"
                                                                                value={item.ProjectRole || null}
                                                                                onChange={(_, newValue) => handleProjectRole(newValue, index)}
                                                                                options={selectedProjectRole}

                                                                                getOptionLabel={(option) => option.Name || ""}
                                                                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                                                renderInput={(params) => (
                                                                                    <TextField {...params} placeholder="Project Role" />
                                                                                )}
                                                                                renderOption={(props, option) => (
                                                                                    <li {...props} key={option.Id}>
                                                                                        {option.Name}
                                                                                    </li>
                                                                                )}
                                                                            />

                                                                        </FormControl>

                                                                        <FormControl size="small" fullWidth sx={{ width: 130 }}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    inputFormat="dd/MMM/yyyy"
                                                                                    value={item.StartDate || null}
                                                                                    onChange={(date) => handleFromDate(date, index)}
                                                                                    renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} placeholder="From Date"
                                                                                    />}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </FormControl>
                                                                        <TextField
                                                                            size="small"
                                                                            placeholder="Costing"
                                                                            value={item.Costing || ""}
                                                                            onChange={(e) => handleCosting(e, index)}
                                                                            sx={{ width: 130 }}
                                                                        />

                                                                        <Button
                                                                            variant="contained"
                                                                            color="secondary"
                                                                            onClick={() => handleSaveChanges(index)}
                                                                            sx={{ width: 130 }}
                                                                        >
                                                                            Save Changes
                                                                        </Button>
                                                                    </Stack>
                                                                </Box>
                                                            )}
                                                        </Card>
                                                    );
                                                })}
                                            </Box>
                                        </>
                                    )}
                                </Box>

                                <Box
                                    sx={{
                                        position: "sticky",
                                        bottom: 0,
                                        zIndex: 10,
                                        backgroundColor: "#fff",
                                        px: 2,
                                        py: 1.5,
                                        borderTop: '1px solid #D1D5DB',
                                    }}
                                >
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">

                                        {/* LEFT SIDE */}
                                        {step === 2 ? (
                                            <Button
                                                variant="outlined"
                                                onClick={() => setStep(1)}
                                                sx={{
                                                    borderRadius: "8px",
                                                    textTransform: "none",
                                                    color: "#374151",
                                                    background: '#F3F4F6',
                                                    border: "1px solid #D1D5DB"
                                                }}
                                            >
                                                Back
                                            </Button>
                                        ) : (
                                            <Box /> // empty space for alignment
                                        )}

                                        {/* RIGHT SIDE */}
                                        <Stack direction="row" spacing={2}>
                                            <Button
                                                variant="outlined"
                                                onClick={handleCloseAddModal}
                                                sx={{
                                                    borderRadius: "8px",
                                                    textTransform: "none",
                                                    bgcolor: '#F3F4F6',
                                                    color: '#374151',
                                                    border: "1px solid #D1D5DB"

                                                }}
                                            >
                                                Cancel
                                            </Button>

                                            {step === 1 ? (
                                                <Button
                                                    variant="contained"
                                                    onClick={handleNext}
                                                    sx={{
                                                        bgcolor: "#D4183D",
                                                        borderRadius: "8px",
                                                        textTransform: "none",
                                                        color: "#FFFFFF",
                                                        "&:hover": { bgcolor: "#D4183D" },
                                                    }}
                                                >
                                                    Next ({checkboxSelection.length})
                                                </Button>
                                            ) : (
                                                <Button variant="contained"
                                                    onClick={handleAddMember}

                                                >
                                                    Add Member({checkboxSelection.length})
                                                </Button>
                                            )}
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Box>
                        </Modal>

                        <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: 444,
                                    bgcolor: "#fff",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    p: 1,
                                    // height: 138
                                }}
                            >
                                {/* MESSAGE */}
                                <Typography fontSize="14px" fontWeight="600">
                                    Are you sure you want to inactive{" "}
                                    <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                        {selectedTeamMember?.ExecutiveName}
                                    </span>{" "}
                                    from the team{" "}
                                    <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                        “{selectedTeamMember?.TeamName}”?
                                    </span>
                                    ?
                                </Typography>
                                {/* ACTIONS */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: 2,
                                        mt: 3,
                                    }}
                                >
                                    {/* NO */}
                                    <Typography
                                        onClick={() => setOpenDeleteModal(false)}
                                        sx={{
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            fontWeight: 600,
                                            color: "#000",
                                            fontSize: '14px'
                                        }}
                                    >
                                        Cancel
                                    </Typography>

                                    {/* YES */}
                                    <Button
                                        variant="contained"
                                        onClick={handleInactiveTeamMemberConfirmClick}
                                        sx={{
                                            backgroundColor: "#FF2B2B",
                                            borderRadius: "8px",
                                            px: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            "&:hover": {
                                                backgroundColor: "#FF2B2B",
                                            },
                                            fontSize: '14px'

                                        }}
                                    >
                                        Confirm
                                    </Button>
                                </Box>
                            </Box>
                        </Modal>

                        <Modal open={openDeleteConfirmModal} onClose={handleInactiveTeamMemberCancel}>
                            <Box sx={modalStyle}>
                                {/* HEADER */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 16px',
                                        borderBottom: '1px solid #D1D5DB',
                                        backgroundColor: '#fff',
                                        m: 0,
                                    }}
                                >
                                    <Typography fontSize={14} fontWeight={600}>
                                        Mark as Inactive
                                    </Typography>

                                    <Box
                                        onClick={handleInactiveTeamMemberCancel}
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#F1F1F1",
                                            border: "1px solid #EDEDED",
                                            borderRadius: "6px",
                                            cursor: "pointer"
                                        }}
                                    >
                                        <Icon
                                            icon="material-symbols:close-rounded"
                                            width={18}
                                            style={{ color: "#000000" }}
                                        />
                                    </Box>
                                </Box>

                                <Box sx={{ py: 1.5, px: 2, overflow: 'auto' }}>

                                    {/* USER CARD */}
                                    <Box
                                        sx={{
                                            border: "1px solid #D1D5DB",
                                            borderRadius: "8px",
                                            p: 2,
                                            background: "#F9FAFB",
                                        }}
                                    >
                                        {/* NAME + ROLE */}
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Icon icon="mdi:account-outline" width={16} color="#717883" />

                                            <Typography fontWeight={500} color="#3D3838">
                                                {selectedTeamMember?.ExecutiveName}
                                            </Typography>

                                            {selectedTeamMember?.IsCoOrdinator && (
                                                <Chip
                                                    label="Coordinator"
                                                    size="small"
                                                    sx={{
                                                        bgcolor: "#374151",
                                                        color: "#fff",
                                                        fontSize: 10,
                                                        height: 22,
                                                        borderRadius: '6px'
                                                    }}
                                                />
                                            )}
                                        </Stack>

                                        {/* CODE + DEPT */}
                                        <Typography sx={{ color: "#717883", mt: 0.5 }}>
                                            {selectedTeamMember?.ExecutiveERPCode} • {selectedTeamMember?.Department}
                                        </Typography>

                                        <Divider sx={{ my: 1.5, color: '#D1D5DB' }} />

                                        {/* DETAILS GRID */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ color: "#717883", }}>
                                                    Client
                                                </Typography>
                                                <Typography fontWeight={500} color='#3D3838'>
                                                    {selectedTeamMember?.ClientName}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Typography sx={{ color: "#717883", }}>
                                                    Project
                                                </Typography>
                                                <Typography fontWeight={500} color='#3D3838'>
                                                    {selectedTeamMember?.Project}
                                                </Typography>
                                            </Grid>
                                            <Divider sx={{ my: 1 }} />

                                            <Grid item xs={6}>
                                                <Typography sx={{ color: "#717883", }}>
                                                    Active Since
                                                </Typography>
                                                <Typography fontWeight={500} color='#3D3838'>
                                                    {selectedTeamMember?.FromDate
                                                        ? Moment(selectedTeamMember.FromDate).format('DD-MMM-YYYY')
                                                        : ""}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Typography sx={{ color: "#717883", }}>
                                                    Team
                                                </Typography>
                                                <Typography fontWeight={500} color='#3D3838'>
                                                    {selectedTeamMember?.TeamName}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    {/* DATE FIELD */}
                                    <Box mt={1}>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            fontSize: '12px',
                                            fontWeight: 500,
                                            color: "#3D3838",
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Set End Date</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                inputFormat="dd/MMM/yyyy"
                                                value={teamMemberEndDate ? Moment(teamMemberEndDate, 'DD-MMM-YYYY').toDate() : null}
                                                onChange={handleTeamMemberEndDate}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        size="small"
                                                        error={false}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            placeholder: teamMemberEndDate ? params.inputProps?.placeholder : "Present"
                                                        }}
                                                    />
                                                )}
                                                sx={{ mt: 1 }}

                                            />
                                        </LocalizationProvider>

                                        <Typography sx={{ fontSize: 10, color: "#8A8E94", mt: 0.5 }}>
                                            This date will be set as the end date for this member.
                                        </Typography>
                                    </Box>

                                </Box>
                                {/* ACTIONS */}

                                <Box sx={{ backgroundColor: "#fff", px: 2, py: 1, borderBottom: '1px solid #D1D5DB', }}>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                                        <Button
                                            variant="outlined"
                                            onClick={handleInactiveTeamMemberCancel}
                                            sx={{ borderRadius: "8px", textTransform: "none", bgcolor: '#F3F4F6', color: '#374151' }}
                                        >
                                            Cancel
                                        </Button>

                                        <Button
                                            variant="contained"
                                            onClick={() => handleInactiveTeamMemberConfirm(selectedTeamMember)}
                                            sx={{
                                                bgcolor: "#D4183D",
                                                borderRadius: "8px",
                                                textTransform: "none",
                                                color: "#FFFFFF",
                                                "&:hover": { bgcolor: "#D4183D" },
                                            }}
                                        >
                                            Mark as Inactive
                                        </Button>
                                    </Stack>
                                </Box>

                            </Box>
                        </Modal>

                        <Modal open={coordinatorModal} onClose={() => setCoordinatorModal(false)}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: 444,
                                    bgcolor: "#fff",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    p: 1,
                                    // height: 138
                                }}
                            >
                                {/* MESSAGE */}
                                <Typography fontSize="14px" fontWeight="600">
                                    Are you sure you want to assign{" "}
                                    <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                        {isAddFlow
                                            ? (selectedTeamMember?.Name || "").split("-")[0]
                                            : selectedTeamMember?.ExecutiveName}
                                    </span>{" "}
                                    the Coordinator of the team?

                                    {existingCoordinator && (
                                        <>
                                            {" "}
                                            <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                                {existingCoordinator?.ExecutiveName ||
                                                    (existingCoordinator?.Name || "").split("-")[0]}
                                            </span>{" "}
                                            is currently the coordinator of{" "}
                                            <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                                "{selectedCard?.TeamName}"
                                            </span>.
                                        </>
                                    )}
                                </Typography>
                                {/* ACTIONS */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: 2,
                                        mt: 3,
                                    }}
                                >
                                    {/* NO */}
                                    <Typography
                                        onClick={() => setCoordinatorModal(false)}
                                        sx={{
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            fontWeight: 600,
                                            color: "#000",
                                            fontSize: '14px'
                                        }}
                                    >
                                        Cancel
                                    </Typography>

                                    {/* YES */}
                                    <Button
                                        variant="contained"
                                        onClick={handleChangeCoordinator}
                                        sx={{
                                            backgroundColor: "#FF2B2B",
                                            borderRadius: "8px",
                                            px: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            "&:hover": {
                                                backgroundColor: "#FF2B2B",
                                            },
                                            fontSize: '14px'

                                        }}
                                    >
                                        Confirm
                                    </Button>
                                </Box>
                            </Box>
                        </Modal>

                        {/* ✅ WHEN createNew = true → NEW / EDIT UI */}
                        {createNew && selectedMembers?.length > 0 && (
                            <Box width="100%">
                                {selectedMembers.map((item, index) => {
                                    const isEdit = editIndex === index;

                                    return (
                                        <Card
                                            key={index}
                                            sx={{
                                                mb: 1,
                                                p: 1,
                                                borderRadius: "15px",
                                                border: "1px solid #E5E5E5",
                                                boxShadow: "none",
                                            }}
                                        >
                                            {!isEdit ? (
                                                //  PREVIEW MODE 
                                                <Stack direction="row" justifyContent="space-between">
                                                    <Box>
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography fontWeight={500} fontSize={14}>
                                                                {(item.Name || "").split("-")[0]}{" "}
                                                                <Box component="span" sx={{ color: "#717182", fontWeight: 400 }}>
                                                                    ({(item.Name || "").split("-")[1] || ""}) ({item.Id})
                                                                </Box>
                                                            </Typography>

                                                            <Chip
                                                                label={item.Department || ""}
                                                                size="small"
                                                                sx={{
                                                                    border: "1px solid #E5E5E5",
                                                                    borderRadius: "6px",
                                                                    fontSize: "10px",
                                                                    fontWeight: 500,
                                                                    color: "#4A4949"
                                                                }}
                                                            />
                                                            {item.IsCoordinator === 1 && (
                                                                <Chip
                                                                    label="Coordinator"
                                                                    size="small"
                                                                    sx={{ bgcolor: "#121212", color: "#fff" }}
                                                                />
                                                            )}
                                                        </Stack>

                                                        <Typography sx={{ color: "#717182", mt: 0.5 }}>
                                                            {item.isSaved ? item.ProjectRole?.Name : item.Designation} •
                                                            {item.StartDate
                                                                ? Moment(item.StartDate).format('DD-MMM-YYYY')
                                                                : Moment().format('DD-MMM-YYYY')
                                                            } •
                                                            Costing: {item.isSaved ? item.Costing || 0 : 0}
                                                        </Typography>
                                                    </Box>

                                                    {/* ACTIONS */}
                                                    <Stack direction="row" spacing={1}>
                                                        <Icon
                                                            icon="material-symbols:border-color-outline"
                                                            width={20}
                                                            color="#374151"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                setEditIndex(index);
                                                                setEditData({
                                                                    role: item.Role || "",
                                                                    date: item.StartDate || "",
                                                                    costing: item.Costing || "",
                                                                });
                                                            }}
                                                        />
                                                        <Icon
                                                            icon={
                                                                item.IsCoordinator === 1
                                                                    ? "material-symbols:person-cancel-outline-rounded"
                                                                    : "material-symbols:person-check-outline-rounded"
                                                            }
                                                            width={20}
                                                            style={{
                                                                color: item.IsCoordinator === 1 ? "#D4183D" : "#0062FF",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => handleCoordinatorToggle(index)}
                                                        />
                                                        <Box
                                                            sx={{
                                                                bgcolor: "#D93A46",
                                                                width: 20,
                                                                height: 20,
                                                                borderRadius: "5px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            onClick={() => handleDeleteClick(index)}

                                                        >
                                                            <Icon icon="material-symbols:delete-outline-rounded" color="#fff" width={14} />
                                                        </Box>
                                                    </Stack>
                                                </Stack>
                                            ) : (
                                                // ✅ EDIT MODE (SECOND IMAGE)
                                                <Box>
                                                    {/* TOP ROW */}
                                                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>

                                                        <Typography fontWeight={500} fontSize={14}>
                                                            {(item.Name || "").split("-")[0]}{" "}
                                                            <Box component="span" sx={{ color: "#717182", fontWeight: 400 }}>
                                                                ({(item.Name || "").split("-")[1] || ""}) ({item.Id})
                                                            </Box>
                                                        </Typography>
                                                        <Chip label={item.Department} size="small" />
                                                        {item.IsCoordinator === 1 && (
                                                            <Chip
                                                                label="Coordinator"
                                                                size="small"
                                                                sx={{ bgcolor: "#121212", color: "#fff" }}
                                                            />
                                                        )}
                                                        {/* ACTIONS */}
                                                        <Stack direction="row" spacing={1}>
                                                            <Icon
                                                                icon={
                                                                    item.IsCoordinator === 1
                                                                        ? "material-symbols:person-cancel-outline-rounded"
                                                                        : "material-symbols:person-check-outline-rounded"
                                                                }
                                                                width={20}
                                                                style={{
                                                                    color: item.IsCoordinator === 1 ? "#D4183D" : "#0062FF",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => handleCoordinatorToggle(index)}
                                                            />
                                                            <Box
                                                                sx={{
                                                                    bgcolor: "#D93A46",
                                                                    width: 20,
                                                                    height: 20,
                                                                    borderRadius: "5px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                                onClick={() => handleDeleteClick(index)}

                                                            >
                                                                <Icon icon="material-symbols:delete-outline-rounded" color="#fff" width={14} />
                                                            </Box>
                                                        </Stack>
                                                    </Stack>

                                                    {/* EDIT FIELDS */}
                                                    <Stack direction="row" spacing={1} alignItems="center">

                                                        <FormControl size="small" fullWidth sx={{ width: 130 }}>

                                                            <Autocomplete
                                                                fullWidth
                                                                limitTags={2}
                                                                size="small"
                                                                id="role"
                                                                value={item.ProjectRole || null}
                                                                onChange={(_, newValue) => handleProjectRole(newValue, index)}
                                                                options={selectedProjectRole}

                                                                getOptionLabel={(option) => option.Name || ""}
                                                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} placeholder="Project Role" />
                                                                )}
                                                                renderOption={(props, option) => (
                                                                    <li {...props} key={option.Id}>
                                                                        {option.Name}
                                                                    </li>
                                                                )}
                                                            />

                                                        </FormControl>

                                                        <FormControl size="small" fullWidth sx={{ width: 130 }}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DesktopDatePicker
                                                                    inputFormat="dd/MMM/yyyy"
                                                                    value={item.StartDate || null}
                                                                    onChange={(date) => handleFromDate(date, index)}
                                                                    renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} placeholder="From Date"
                                                                    />}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                        <TextField
                                                            size="small"
                                                            placeholder="Costing"
                                                            value={item.Costing || ""}
                                                            onChange={(e) => handleCosting(e, index)}
                                                            sx={{ width: 130 }}
                                                        />

                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => handleSaveChanges(index)}
                                                            sx={{ width: 130 }}
                                                        >
                                                            Save Changes
                                                        </Button>
                                                    </Stack>
                                                </Box>
                                            )}
                                        </Card>
                                    );
                                })}
                            </Box>
                        )}

                        <Modal open={deleteModal} onClose={handleDeleteCloseModal}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: 444,
                                    bgcolor: "#fff",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    p: 1,
                                    // height: 138
                                }}
                            >
                                {/* MESSAGE */}
                                <Typography fontSize="14px" fontWeight="600">
                                    Are you sure you want to remove{" "}
                                    <span style={{ color: "#155DFC", fontWeight: 600 }}>
                                        “{selectedMembers[deleteIndex]?.Name}?”
                                    </span>{" "}
                                </Typography>
                                {/* ACTIONS */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: 2,
                                        mt: 3,
                                    }}
                                >
                                    {/* NO */}
                                    <Typography
                                        onClick={handleDeleteCloseModal}
                                        sx={{
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            fontWeight: 600,
                                            color: "#000",
                                            fontSize: '14px'
                                        }}
                                    >
                                        No
                                    </Typography>

                                    {/* YES */}
                                    <Button
                                        variant="contained"
                                        onClick={() => handleDelete()}
                                        sx={{
                                            backgroundColor: "#FF2B2B",
                                            borderRadius: "8px",
                                            px: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            "&:hover": {
                                                backgroundColor: "#FF2B2B",
                                            },
                                            fontSize: '14px'

                                        }}
                                    >
                                        Yes
                                    </Button>
                                </Box>
                            </Box>
                        </Modal>
                    </Box>
                </Card>
            </Box>

            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}

        </Box >

    )
}

